import api from "../../API/apiConfig";

export const userList = async (id) => {
    return await api.get(`users/${id}`);
}

export const userDetail = async (id) => {
    return await api.get(`users/detail/${id}`);
}

export const deleteUser = async (id) => {
    return await api.delete(`users/delete/${id}`);
}

export const createUser = async (params) => {
    return await api.post(`users/add`, params);
}

export const updateUser = async (id, username) => {
    return await api.put(`users/update/${id}`, { username });
}

export const updateUserRole = async (id, role) => {
    return await api.put(`users/update-role/${id}?role=${role}`);
}

export const userListByRole = async (id, role) => {
    return await api.get(`users/${id}?role=${role}`);
}